import React, {FC, PropsWithChildren, ReactElement} from 'react';
import styled, {css} from 'styled-components';

import {CleanHtml, emptyCleanHtml} from '../../../../../libs/shared/core/src/helpers/typescript/cleanHtml';
import {TimelineVariationsEnum} from '../../../../../libs/shared/core/src/store/timelineVariations/timelineVariationsTypes';
import {textSelection} from '../../../../../libs/shared/ui/src/styles/mixins';
import {MessageHtml} from '../../viewer/activity/message/messageHtml';

/*
 * Props.
 */

interface EmailComposerStaticProps {
  /** Whether to apply a faux blockquote style to the content, such as for a reply quote. */
  shouldAddQuoteStyle?: boolean;
  html?: CleanHtml;
  timelineVariation: TimelineVariationsEnum;
  isReadonly?: boolean;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div<{$isReadonly?: boolean}>`
  padding: 8px 16px;
  ${textSelection()};

  ${(p) =>
    p.$isReadonly &&
    css`
      cursor: not-allowed;
    `}
`;

const StyledQuoteDiv = styled.div`
  border-left: 1px solid ${(p) => p.theme.palette.grey.shade30};
  padding-left: 10px;
`;

/*
 * Component.
 */

export const EmailComposerStatic: FC<PropsWithChildren<EmailComposerStaticProps>> = ({
  shouldAddQuoteStyle,
  html,
  timelineVariation,
  isReadonly,
}) => (
  <StyledWrapperDiv $isReadonly={isReadonly}>
    {maybeWrapInQuote(
      <MessageHtml
        trustedHtml={html || emptyCleanHtml}
        timelineVariation={TimelineVariationsEnum.ASYNCHRONOUS}
      />,
      Boolean(shouldAddQuoteStyle),
    )}
  </StyledWrapperDiv>
);

function maybeWrapInQuote(children: ReactElement<any>, shouldWrap: boolean): ReactElement<any> {
  if (!shouldWrap) {
    return children;
  }

  return <StyledQuoteDiv>{children}</StyledQuoteDiv>;
}
